import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinjunnarpune() {



  const cardData =
  {
    keyword: 'Bus On Rent in Junnar Pune',
    heading: 'Sanavi Travels: Bus On Rent in Junnar Pune',
    headingDescription: 'Bus On Rent in Junnar Pune provides safe, comfortable, and affordable bus rental services for local trips, outstation travel, sightseeing tours, corporate events, school picnics, weddings, and group travel. With a fleet of AC and Non-AC buses, mini buses, and luxury coaches ranging from 17 to 50 seaters, we ensure well-maintained vehicles, spacious seating, and professional chauffeurs for a smooth journey. Offering flexible rental packages, transparent pricing, doorstep pickup, and 24/7 booking support, bus on rent in Junnar Pune is the ideal choice for reliable and hassle-free group transportation to Pune, Mumbai, Nashik, Shirdi, Mahabaleshwar, and other destinations.',

    top: 'Top Places to Visit in Junnar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Junnar Town",
    "description": "Junnar is a historic town in Pune district with deep roots in ancient Indian history, trade, and culture. Once an important center during the Satavahana and later Maratha periods, Junnar is surrounded by hills, forts, and ancient caves. The town offers a unique blend of archaeology, spirituality, rural life, and natural beauty, making it an important heritage destination in Maharashtra."
  },
  {
    "title": "Lenyadri Ganpati Temple",
    "description": "Lenyadri Ganpati Temple is one of the eight revered Ashtavinayak temples of Maharashtra. Carved into a Buddhist rock-cut cave, the temple is dedicated to Lord Ganesha and holds immense spiritual significance. Reached by climbing stone steps, the cave offers a serene atmosphere along with panoramic views of the surrounding hills."
  },
  {
    "title": "Shivneri Fort",
    "description": "Shivneri Fort is the birthplace of Chhatrapati Shivaji Maharaj and one of the most important historical forts in India. The fort is well-preserved with strong fortifications, water tanks, temples, and the Shiv Janmabhoomi temple. Trekking to Shivneri provides a powerful connection to Maratha history and offers stunning views of the surrounding region."
  },
  {
    "title": "Manmodi Caves",
    "description": "The Manmodi Caves are a group of ancient Buddhist rock-cut caves dating back to the Satavahana period. Known for their simplicity, water cisterns, and meditation halls, these caves highlight the spiritual and architectural heritage of ancient India."
  },
  {
    "title": "Tulja Caves",
    "description": "Tulja Caves are lesser-known Buddhist caves located near Junnar. These caves are valued for their peaceful surroundings and historical importance, offering visitors a quiet and reflective heritage experience."
  },
  {
    "title": "Naneghat",
    "description": "Naneghat is an ancient mountain pass near Junnar that once served as a major trade route connecting the Deccan Plateau to the Konkan coast. Famous for its rock-cut inscriptions, giant stone jar, and panoramic viewpoints, Naneghat is also a popular trekking destination and monsoon attraction."
  },
  {
    "title": "Harishchandragad (Nearby)",
    "description": "Located close to Junnar, Harishchandragad is a majestic hill fort known for the iconic Konkan Kada cliff, ancient temples, and challenging treks. It attracts adventure seekers, photographers, and history lovers from across Maharashtra."
  },
  {
    "title": "Junnar Vineyards and Farmlands",
    "description": "The fertile lands around Junnar are known for grape cultivation and vineyards. Visitors can explore agricultural landscapes, learn about farming practices, and enjoy scenic countryside views."
  },
  {
    "title": "Ancient Temples of Junnar",
    "description": "Junnar is dotted with old temples dedicated to Lord Shiva, Goddess Parvati, and local deities. These temples reflect traditional architecture and play a vital role in the cultural and spiritual life of the region."
  },
  {
    "title": "Monsoon Landscapes and Waterfalls",
    "description": "During the monsoon season, the hills around Junnar come alive with greenery, mist, and seasonal waterfalls. The region becomes a visual treat for nature lovers and photographers, offering refreshing weather and breathtaking scenery."
  }
]
,



"services": [
{
"name": "Bus On Rent in Junnar Pune",
"description": "Bus On Rent in Junnar Pune offers comfortable and reliable buses for local and outstation travel. Perfect for families, groups, tourists, and corporate travelers, these buses ensure a smooth, safe, and timely journey. Professional drivers, spacious seating, flexible schedules, and well-maintained vehicles make it ideal for weddings, sightseeing trips, corporate events, and group excursions in and around Junnar and Pune."
},
{
"name": "Bus Hire Junnar",
"description": "Bus Hire Junnar provides convenient and customized bus rental services for weddings, corporate trips, group tours, and long-distance travel. With modern buses, experienced drivers, and flexible itineraries, it ensures a comfortable, safe, and stress-free travel experience for passengers traveling to or from Junnar."
},
{
"name": "AC Bus Junnar",
"description": "AC Bus Junnar offers fully air-conditioned buses for a refreshing and comfortable journey. Ideal for long-distance travel, family outings, corporate trips, and tourist excursions, these buses provide smooth rides, professional drivers, and spacious interiors to make travel enjoyable and hassle-free across Junnar and surrounding areas."
},
{
"name": "Luxury Bus Junnar",
"description": "Luxury Bus Junnar delivers premium buses with elegant seating, modern amenities, and spacious interiors. Perfect for VIP travelers, corporate groups, and special events like weddings or parties, these buses combine style, comfort, and safety to ensure a luxurious travel experience in Junnar and nearby regions."
},
{
"name": "Wedding Bus Junnar",
"description": "Wedding Bus Junnar specializes in providing spacious and comfortable buses for wedding parties, family events, and group transportation. With professional drivers, timely service, and well-maintained vehicles, it ensures a smooth, safe, and memorable travel experience for all attendees in and around Junnar."
},
{
"name": "Corporate Bus Junnar",
"description": "Corporate Bus Junnar offers professional transportation for office teams, corporate events, and business travel. With modern buses, punctual service, experienced drivers, and comfortable interiors, it ensures reliable and efficient transport solutions for companies traveling to or from Junnar."
},
{
"name": "Outstation Bus Junnar",
"description": "Outstation Bus Junnar provides safe and comfortable buses for long-distance travel to neighboring cities and tourist destinations. Perfect for families, friends, and corporate travelers, these buses offer spacious seating, professional drivers, and flexible schedules for convenient and stress-free journeys from Junnar."
},
{
"name": "Affordable Bus Junnar",
"description": "Affordable Bus Junnar combines budget-friendly pricing with reliable and comfortable bus services. Ideal for students, families, and group travelers, it ensures spacious seating, professional drivers, and timely service without compromising safety or convenience for travel to and from Junnar."
},
{
"name": "Chauffeur Driven Bus Junnar",
"description": "Chauffeur Driven Bus Junnar provides professional drivers who handle navigation, traffic, and scheduling, offering passengers a stress-free travel experience. Suitable for group travel, corporate outings, weddings, and tourist trips, it ensures smooth, safe, and comfortable journeys in and around Junnar."
},
{
"name": "Best Bus Service Junnar",
"description": "Best Bus Service Junnar is known for punctuality, well-maintained vehicles, and exceptional customer support. Catering to families, tourists, corporate clients, and group travelers, it provides safe, reliable, and comfortable transportation for weddings, events, outings, and long-distance journeys from Junnar."
},
{
"name": "Tourist Bus Junnar",
"description": "Tourist Bus Junnar caters to travelers exploring Junnar and nearby attractions. With organized itineraries, experienced drivers, and comfortable buses, it provides hassle-free sightseeing experiences, allowing tourists to enjoy historical, cultural, and scenic destinations without worrying about transportation logistics."
},
{
"name": "Group Travel Bus Junnar",
"description": "Group Travel Bus Junnar specializes in transporting friends, families, corporate teams, and social groups efficiently and comfortably. With spacious buses, professional drivers, and organized travel plans, it ensures coordinated, enjoyable, and safe group trips in and around Junnar."
},
{
"name": "Online Bus Booking Junnar",
"description": "Online Bus Booking Junnar allows passengers to reserve buses quickly and conveniently with instant confirmation. Offering multiple bus options, transparent pricing, and flexible schedules, it simplifies travel planning for families, tourists, corporate clients, and local commuters traveling to or from Junnar."
},
{
"name": "Event Bus Junnar",
"description": "Event Bus Junnar provides dedicated buses for weddings, corporate events, parties, and other special occasions. With professional drivers, spacious vehicles, and reliable service, it ensures organized, safe, and comfortable transportation for all attendees in Junnar and surrounding areas."
},
{
"name": "Junnar Travel Bus",
"description": "Junnar Travel Bus offers complete bus rental solutions for sightseeing trips, corporate travel, weddings, and outstation journeys. Combining safety, comfort, affordability, and professional service, it caters to families, tourists, and corporate clients seeking convenient and dependable transportation in Junnar and Pune."
}
],
"tableData": [
["Bus On Rent in Junnar Pune", "Bus Hire Junnar"],
["AC Bus Junnar", "Luxury Bus Junnar"],
["Wedding Bus Junnar", "Corporate Bus Junnar"],
["Outstation Bus Junnar", "Affordable Bus Junnar"],
["Chauffeur Driven Bus Junnar", "Best Bus Service Junnar"],
["Tourist Bus Junnar", "Group Travel Bus Junnar"],
["Online Bus Booking Junnar", "Event Bus Junnar"],
["Junnar Travel Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Junnar Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable bus rental services in Junnar Pune, perfect for group outings, pilgrimages, school trips, and family travel."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air‑conditioned, and regularly serviced to ensure a smooth and enjoyable journey throughout Junnar Pune and nearby areas."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Junnar Pune routes, ensuring safe, punctual, and stress‑free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for bus rentals in Junnar Pune, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your bus rental in Junnar Pune."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your group’s needs and travel schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rentals in Junnar Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Junnar Pune?',
    answer: 'Yes, Sanavi Travels offers reliable bus rental services in Junnar Pune for various travel needs.'
  },
  {
    question: 'How can I book a bus in Junnar Pune?',
    answer: 'You can easily book a bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rent in Junnar Pune?',
    answer: 'Sanavi Travels offers a variety of buses including mini buses, 20‑seater, 32‑seater, 45‑seater, and 50‑seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with routes around Junnar Pune?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Junnar Pune routes, ensuring safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations in Junnar Pune?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations anywhere in Junnar Pune and nearby areas.'
  },
  {
    question: 'Is the bus service in Junnar Pune available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock bus rental services in Junnar Pune to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bus rental bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip in Junnar Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Shinde',
    feedback: 'We booked a bus in Junnar Pune from Sanavi Travels — excellent service, clean bus, and a very comfortable trip!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Divya Patil',
    feedback: 'Sanavi Travels provided a reliable and stress‑free bus rental experience in Junnar Pune. Highly recommended!',
    rating: 5
  }
];


























































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusReservation",
  "name": "Bus On Rent in Junnar Pune - Sanavi Travels",
  "description": "Sanavi Travels offers bus rental services in Junnar Pune including AC, luxury, wedding, corporate, and outstation buses. Perfect for group travel, tourist trips, events, and online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "28"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Bus On Rent in Junnar Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC, luxury, wedding, corporate, and outstation buses in Junnar Pune with Sanavi Travels. Ideal for group travel, events, and tourist trips. Online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/147.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinjunnarpune;